var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    strokeOpacity: 0,
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5,4.5V2.375a.375.375,0,0,0-.636-.269L.114,6.231a.374.374,0,0,0,0,.538l4.25,4.125A.375.375,0,0,0,5,10.625V8.5h.709a6.376,6.376,0,0,1,5.576,3.286l.01.019a.375.375,0,0,0,.329.195.37.37,0,0,0,.093-.012A.375.375,0,0,0,12,11.625,7.133,7.133,0,0,0,5,4.5Z",
    transform: "translate(12 12) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.4120adaa602474d53618491ce1434215.svg";
export { ForwardRef as ReactComponent };